import { useState } from 'react'

const DEFAULT_PER_PAGE = 10

export const usePagination = (props) => {
  const [page, setPage] = useState(props?.page || 1)
  const [total, setTotal] = useState(0)
  const [perPage, setPerPage] = useState(props?.perPage || DEFAULT_PER_PAGE)

  return {
    page,
    perPage,
    setPage,
    total,
    setTotal,
    setPerPage,
  }
}
